import { selectors as modals } from './modals';
export const selectors = { modals };
